import { createFileRoute } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import { Section } from "@/components/site/Section";
import { customerLinks } from "@/content/site";

export const Route = createFileRoute("/area-do-cliente")({
  head: () => ({
    meta: [
      { title: "Área do cliente — Contato Internet" },
      {
        name: "description",
        content:
          "Segunda via de boleto, pagamento via PIX, webmail, contratos e downloads da Contato Internet em um só lugar.",
      },
      { property: "og:title", content: "Área do cliente — Contato Internet" },
      {
        property: "og:description",
        content: "Boleto, PIX, webmail, contratos e downloads em um só lugar.",
      },
    ],
  }),
  component: AreaClientePage,
});

function AreaClientePage() {
  return (
    <Section
      eyebrow="Autoatendimento"
      title="Área do cliente"
      text="Resolva tudo sozinho, a qualquer hora. Se precisar de ajuda, é só chamar no WhatsApp."
    >
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {customerLinks.map((l) => (
          <a
            key={l.label}
            href={l.href}
            target="_blank"
            rel="noreferrer"
            className="group flex items-start justify-between gap-4 rounded-3xl border border-border bg-card p-7 transition-all hover:-translate-y-1 hover:border-primary/40 hover:shadow-lg"
          >
            <span>
              <span className="block text-lg font-extrabold">{l.label}</span>
              <span className="mt-1 block text-sm text-muted-foreground">{l.desc}</span>
            </span>
            <ArrowUpRight className="size-5 shrink-0 text-primary transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        ))}
      </div>
    </Section>
  );
}
